
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"5.5","cy":"15.5","r":"1.5"}}),_c('path',{attrs:{"d":"M19 3H5a5.006 5.006 0 00-5 5v8a5.006 5.006 0 005 5h14a5.006 5.006 0 005-5V8a5.006 5.006 0 00-5-5zM5 5h14a3 3 0 013 3H2a3 3 0 013-3zm14 14H5a3 3 0 01-3-3v-6h20v6a3 3 0 01-3 3z"}})])
          )
        }
      }
    